<template>
  <div class="frame">
    <div v-if="linkExpired">
      <h1>{{ $t('sweeps.linkExpiredMessage') }}</h1>
      <a :href="helpcenterLink" v-on:click="redirectToHelpcenter">
        {{ $t('sweeps.backtoHcLinkText') }}
      </a>
    </div>
    <div v-if="!linkExpired">
      <div class="heading">
        <span>{{ $t('sweeps.title1', [this.siteName, this.prizeName]) }}</span>
        <br />
        <span>{{ $t('sweeps.title2') }}</span>
      </div>
      <form id="sweeps-winner-affidavit-form">
        <label for="fullName">{{ $t('sweeps.fullNameLabel') }}</label>
        <input type="text" id="fullName" class="input ba h-35 br5 pa0 w-100" aria-required="true" v-model="fullName" />
        <label for="street">
          <span>{{ $t('sweeps.streetLabel1') }}</span> <span style="font-weight: normal;">{{ $t('sweeps.streetLabel2') }}</span>
        </label>
        <input type="text" id="street" class="input ba h-35 br5 pa0 w-100" aria-required="true" v-model="street" />
        <label for="city">{{ $t('sweeps.cityLabel') }}</label>
        <input type="text" id="city" class="input ba h-35 br5 pa0 w-100" aria-required="true" v-model="city" />
        <label for="state">{{ $t('sweeps.stateLabel') }}</label>
        <input type="text" id="state" class="input ba h-35 br5 pa0 w-100" aria-required="true" v-model="state" />
        <label for="zip">{{ $t('sweeps.zipCodeLabel') }}</label>
        <input type="text" id="zip" class="input ba h-35 br5 pa0 w-100" aria-required="true" v-model="zip" />
        <label for="country">{{ $t('sweeps.countryLabel') }}</label>
        <input type="text" id="country" class="input ba h-35 br5 pa0 w-100" aria-required="true" v-model="country" />
        <label for="dob">
          <span>{{ $t('sweeps.dateOfBirthLabel1') }}</span> <span style="font-weight: normal;">{{ $t('sweeps.dateOfBirthLabel2') }}</span>
        </label>
        <input type="date" id="dob" class="input ba h-35 br5 pa0 w-100" aria-required="true" v-model="dob" />
        <label for="phone">
          <span>{{ $t('sweeps.phoneNumberLabel1') }}</span> <span style="font-weight: normal;">{{ $t('sweeps.phoneNumberLabel2') }}</span>
        </label>
        <input type="text" id="phone" class="input ba h-35 br5 pa0 w-100" aria-required="true" v-model="phone" />
        <div>
          <span class="heading" style="text-align:center;">{{ $t('sweeps.instructionsHeading') }}</span>
          <ol>
            <li>
              <span style="text-decoration:underline;">{{ $t('sweeps.instructions1.name') }}</span>
              &nbsp;
              <span>{{ $t('sweeps.instructions1.text', [this.siteName, this.prizeName]) }}</span>
            </li>
            <li>
              <span style="text-decoration:underline;">{{ $t('sweeps.instructions2.name') }}</span>
              &nbsp;
              <span>{{ $t('sweeps.instructions2.text') }}</span>
            </li>
            <li>
              <span style="text-decoration:underline;">{{ $t('sweeps.instructions3.name') }}</span>
              &nbsp;
              <span>{{ $t('sweeps.instructions3.text') }}</span>
            </li>
            <li>
              <span style="text-decoration:underline;">{{ $t('sweeps.instructions4.name') }}</span>
              &nbsp;
              <span>{{ $t('sweeps.instructions4.text', [this.prizeName, this.prizeValue]) }}</span>
            </li>
            <li>
              <span style="text-decoration:underline;">{{ $t('sweeps.instructions5.name') }}</span>
              &nbsp;
              <span>{{ $t('sweeps.instructions5.text') }}</span>
            </li>
            <li>
              <span style="text-decoration:underline;">{{ $t('sweeps.instructions6.name') }}</span>
              &nbsp;
              <span>{{ $t('sweeps.instructions6.text') }}</span>
            </li>
            <li>
              <span style="text-decoration:underline;">{{ $t('sweeps.instructions7.name') }}</span>
              &nbsp;
              <span>{{ $t('sweeps.instructions7.text') }}</span>
            </li>
            <li>
              <span style="text-decoration:underline;">{{ $t('sweeps.instructions8.name') }}</span>
              &nbsp;
              <span>{{ $t('sweeps.instructions8.text') }}</span>
            </li>
          </ol>
          <p>{{ $t('sweeps.agreement1') }}</p>
          <p style="font-weight: bold;">{{ $t('sweeps.agreement2') }}</p>
          <p>{{ $t('sweeps.agreement3') }}</p>
        </div>
        <label for="acknowledgement">
          <input type="checkbox" name="acknowledgement" id="acknowledgement" v-model="acknowledgment" />
          {{ $t('sweeps.acknowledgementLabel') }}
        </label>
        <br />
        <button type="submit" class="h-35 br5 bg-blue white pointer bw0 fs16 w-50" id="submit" v-on:click="submitRequest" :disabled="!canSubmit">
          {{ $t('sweeps.submitButtonText') }}
        </button>
      </form>
      <div class="flex flex-column w-100" role="alert">
        <p id="form-error" class="dark-red" v-if="errorMessage" v-html="errorMessage"></p>
        <p id="form-success" class="dark-green" v-if="successMessage">{{ $t('sweeps.successMessage') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { sweepsApi, environment } from '@/config/index.js';
export default {
  name: 'Sweeps',
  data() {
    return {
      email: '',
      memberId: '',
      prizeName: '',
      prizeValue: '',

      fullName: undefined,
      street: undefined,
      city: undefined,
      state: undefined,
      zip: undefined,
      country: undefined,
      dob: undefined,
      phone: undefined,
      acknowledgment: false,

      siteName: '',
      domainName: '',
      language: '',
      brandSubdomain: '',

      jwt: '',
      jwtExp: null,

      targetOrigin: '',
      apiUrl: '',
      errorMessage: '',
      successMessage: false,
      isActive: true,
      invalidSignature: false,
    };
  },
  computed: {
    helpcenterLink() {
      return environment === 'development' ? `http://localhost:8080/${this.language}` : `https://support.${this.domainName}/${this.language}`;
    },
    linkExpired() {
      return !this.jwtExp || this.jwtExp < Math.round(Date.now() / 1000) || this.invalidSignature;
    },
    isOfAge() {
      if (!this.dob) {
        return false;
      }

      const now = new Date();
      const eighteenYearsAgo = new Date(now.getFullYear() - 18, now.getMonth(), now.getDate());
      const dob = new Date(this.dob);
      return dob.getTime() <= eighteenYearsAgo.getTime();
    },
    canSubmit() {
      return this.isActive && this.acknowledgment && this.fullName && this.street && this.city && this.zip && this.country && this.dob && this.phone && this.isOfAge;
    },
  },
  methods: {
    parseJwt(token) {
      // https://stackoverflow.com/a/38552302
      try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
        );
        return JSON.parse(jsonPayload);
      } catch (err) {
        return null;
      }
    },
    redirectToHelpcenter(e) {
      e.preventDefault();
      window.parent.postMessage(
        {
          type: 'redirect',
          url: this.helpcenterLink,
        },
        this.targetOrigin
      );
    },
    getVariables() {
      this.jwt = this.$route.query.data;
      const jwt = this.parseJwt(this.$route.query.data);
      this.email = jwt ? jwt.email : null;
      this.memberId = jwt ? jwt.memberId : null;
      this.prizeName = jwt ? jwt.segment : null;
      this.prizeValue = jwt ? jwt.segmentValue : null;
      this.jwtExp = jwt ? jwt.exp : null;

      this.siteName = this.$route.query.siteName ? this.$route.query.siteName : null;
      this.domainName = this.$route.query.domainName ? this.$route.query.domainName : null;
      this.language = this.$route.query.language ? this.$route.query.language : null;
      this.brandSubdomain = this.$route.query.helpcenterType ? this.$route.query.helpcenterType : null;

      this.targetOrigin = this.domainName && environment !== 'development' ? `https://support.${this.domainName}` : 'http://localhost:8080';
      this.apiUrl = `${sweepsApi}/affidavits`;
    },
    syncIframeHeight() {
      if (document.body.scrollHeight !== window.innerHeight) {
        window.parent.postMessage(
          {
            type: 'resize',
            height: document.body.scrollHeight,
          },
          this.targetOrigin
        );
      }
    },
    async submitRequest(e) {
      e.preventDefault();
      this.isActive = false;
      this.errorMessage = '';
      this.successMessage = false;
      const request = {
        jwt: this.jwt,
        fullName: this.fullName,
        street: this.street,
        city: this.city,
        state: this.state ? this.state : undefined,
        zip: this.zip,
        country: this.country,
        dob: this.dob ? Math.floor(new Date(this.dob).getTime() / 1000) : undefined,
        phone: this.phone,
        domain: this.domainName,
        brandSubdomain: this.brandSubdomain,
      };
      try {
        const response = await fetch(this.apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(request),
        });
        const data = await response.json();
        if (data?.data?.message !== 'Accepted') {
          if (data?.errors?.[0]?.detail === 'Invalid JWT') {
            this.invalidSignature = true;
          } else {
            this.unsuccessfulHandler();
          }
        }
        if (data?.data?.message === 'Accepted') {
          setTimeout(() => {
            window.parent.postMessage(
              {
                type: 'redirect',
                url: `${this.helpcenterLink}?request=success`,
              },
              this.targetOrigin
            );
          }, 5000);
          this.successMessage = true;
        }
      } catch (err) {
        this.unsuccessfulHandler();
      }
    },
    unsuccessfulHandler() {
      this.errorMessage = this.$t('sweeps.submissionFailure');
      this.isActive = true;
    },
  },
  created() {
    this.getVariables();
    this.$i18n.locale = this.language;
    window.addEventListener('resize', () => {
      this.syncIframeHeight();
    });
  },
  mounted() {
    this.syncIframeHeight();
  },
  updated() {
    this.syncIframeHeight();
  },
  components: {},
};
</script>

<style scoped>
.frame {
  background-color: #f7f4f4;
}

.heading {
  font-weight: bold;
  padding-bottom: 30px;
}

form {
  text-align: left;
}

label {
  font-weight: bold;
}

input {
  margin: 0 0 1em 0;
  outline-color: rgb(64, 169, 243);
  border-color: rgb(204, 204, 204);
}

li {
  padding-bottom: 10px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.bg-gray {
  background-color: #f7f4f4;
}

.bg-blue {
  background-color: #0072ef;
}

.logo {
  width: 43px;
  height: 50px;
}

.pa10 {
  padding: 5px;
}

.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.flex-row {
  flex-direction: row;
}

.justify-center {
  justify-content: center;
}

.items-center {
  align-items: center;
}

.w-25 {
  width: 25%;
}

.w-30 {
  width: 30%;
}

.w-50 {
  width: 50%;
}

.w-75 {
  width: 75%;
}

.w-80 {
  width: 80%;
}

.w-100 {
  width: 100%;
}

.h-35 {
  height: 35px;
}

.ma0 {
  margin: 0;
}

.mr10 {
  margin-right: 10px;
}

.mt20 {
  margin-top: 20px;
}

.mb5 {
  margin-bottom: 5px;
}

.mb10 {
  margin-bottom: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb30 {
  margin-bottom: 30px;
}

.bold {
  font-weight: 400;
}

.container {
  margin-right: auto;
  margin-left: auto;
  padding: 10px;
}

.ba {
  border-style: solid;
  border-width: 1px;
}

.br5 {
  border-radius: 5px;
}

.white {
  color: rgb(255, 255, 255);
}

.pointer {
  cursor: pointer;
}

.bw0 {
  border-width: 0;
}

.button:hover {
  background-color: #004189;
}

.pa0 {
  padding: 0;
}

.pl5 {
  padding-left: 5px;
}

.pr5 {
  padding-right: 5px;
}

.fs12 {
  font-size: 12px;
}

.fs14 {
  font-size: 14px;
}

.fs16 {
  font-size: 16px;
}

p[aria-hidden='true'] {
  opacity: 0;
}

p[aria-hidden='false'] {
  opacity: 1;
}

.h15 {
  height: 10px;
}

input[aria-invalid='true'] {
  border-color: red;
}

button[disabled],
button[disabled]:hover {
  background-color: rgb(221, 221, 221);
  cursor: not-allowed;
}

.dark-red {
  color: #e7040f;
}

.dark-green {
  color: #007728;
}

@media screen and (min-width: 768px) {
  .container {
    width: 75%;
  }

  .w-75-ns {
    width: 75%;
  }
}

@media screen and (min-width: 1440px) {
  .container {
    width: 50%;
  }

  .w-75-ns {
    width: 50%;
  }
}

hr {
  height: 2px;
  background-color: lightgray;
}

/* MODAL */
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 40px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/* MODAL */
/* LOADING MODAL */
.lds-ring {
  display: inline-block;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  width: 64px;
  height: 64px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* LOADING MODAL */
.modal-mask.nd,
.lds-ring.nd,
.nd {
  display: none;
}
</style>
